<template>
    <div>
      <!-- 退出登录 -->
      <logOut />
      <van-tabs v-model="active" color="#8f8ee6" title-active-color="#8f8ee6" @change="change">
        <van-tab title="文章">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
            <contents v-if="active==0" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder" @getGroupId="getGroupId" @getDeptId="getDeptId"></contents>
          </van-list>
        </van-tab>
        <van-tab title="海报">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
            <contents v-if="active==1" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder">
            </contents>
          </van-list>
        </van-tab>
        <van-tab title="表单">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
            <contents v-if="active==2" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder" @getGroupId="getGroupId" @getDeptId="getDeptId"></contents>
          </van-list>
        </van-tab>
        <van-tab title="文件">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtFileLoad">
            <contents v-if="active==3" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder" @getGroupId="getGroupId" @getDeptId="getDeptId"></contents>
          </van-list>
        </van-tab>
        <van-tab title="视频">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
            <contents v-if="active==4" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder" @getGroupId="getGroupId" @getDeptId="getDeptId"></contents>
          </van-list>
        </van-tab>
        <van-tab title="图集">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
            <contents v-if="active==5" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder" @getGroupId="getGroupId" @getDeptId="getDeptId"></contents>
          </van-list>
        </van-tab>
        <van-tab title="外部链接">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
            <contents v-if="active==6" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder" @getGroupId="getGroupId" @getDeptId="getDeptId"></contents>
          </van-list>
        </van-tab>
        <van-tab title="小程序">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
            <contents v-if="active==7" :name='name' :filterList='list' :href='href' @keyword="getkeyword"
              @getBorder="getBorder" @getGroupId="getGroupId" @getDeptId="getDeptId"></contents>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
</template>

<script>
import contents from "../../components/contents"
import ppt from '../../assets/images/ppt.png'
import world from '../../assets/images/world.png'
import excel from '../../assets/images/excel.png'
import pdf from '../../assets/images/pdf.png'
import txtIcon from '../../assets/images/txtIcon.png'
import zipIcon from '../../assets/images/zipIcon.png'
import unknowFileIcon from '../../assets/images/unknowFileIcon.png'
import logOut from "./logOut"

export default {
  components: {
    contents,
    logOut
  },
  data () {
    return {
      memberId: null,
      border: 2,
      groupId: '',
      active: 0,
      name: '文章',
      page: 1,
      pageCount: 10,
      list: [],
      keyword: '',
      loading: false,
      finished: false,
      getCorpId: null,
      href: {
        corpId: ''
      },
      deptId: null,
    }
  },
  created () {
    this.href.corpId = this.$store.state.auth.corpId
    console.log(this.href.corpId, 'this.href.corpId1111')

  },
  methods: {

    getMsg (name) {
      this.page = 1
      this.list = []
      this.loading = true
      this.finished = false
      if (this.border === 1 || this.border === 2) {
        this.deptId = null
      }
      if (this.name === '文件') {
        this.CtFile(false)
      } else {
        this.CtDetailList(this.name, false)
      }
    },
    // 获取组id
    getGroupId (val) {
      this.groupId = val
      this.getMsg()
    },
    getDeptId (val) {
      console.log(val)
      this.deptId = val
      this.getMsg()
    },
    // 获取 owner
    getBorder (val) {
      this.border = Number(val)
      if (this.name === '海报') {
        this.getMsg()
      }
    },
    // 获取 keyword
    getkeyword (val) {
      this.keyword = val
      this.getMsg()
    },
    change (val, name) {
      this.keyword = ''
      this.active = val
      this.name = name
      this.border = 2
      if (this.name === '海报') {
        this.getMsg()
      }
    },

    async CtDetailList (name, load) {
      if (load) {
        this.page++
      }
      let url;
      let params = {
        corpId: this.href.corpId,
        groupId: this.groupId,
        owner: this.border,
        page: this.page,
        pageCount: this.pageCount,
        keyword: this.keyword,
        deptId: this.deptId
      }
      if (name === '文章') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtArticleByPage'
      } else if (name === '海报') {
        this.groupId = ''
        url = '/scrm/v1/wxcp-chat-tool/p/findCtPosterByPage'
      } else if (name === '表单') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtFormByPage'
      } else if (name === '视频') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtVByPage'
      } else if (name === '图集') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtImgListByGroupId'
      } else if (name === '外部链接') {
        url = '/scrm/v1/wxcp-chat-tool/p/findCtUrlListByGroupId'
      } else if (name === '小程序') {
        url = '/scrm/v1/wxcp-chat-tool/p/findQwMiniProgramByPage'
      }

      let res = await this.$http.get(url, {
        params
      })
      this.loading = false
      if (res.code === 1) {
        if (res.data === null) {
          res.data = {}
          res.data.records = []
        }

        if (res.data.records.length !== 0) {
          this.list.push(...res.data.records)
        } else {
          //  this.List=[]
          this.finished = true
        }
        if (this.list.length >= res.total) {
          this.finished = true;	// 结束加载状态
        }
      }
    },
    // 文件
    CtFile (load) {
      if (load) {
        this.page++
      }
      this.$http.get('/scrm/v1/wxcp-chat-tool/p/findCtFileByPage', {
        params: {
          corpId: this.href.corpId,
          groupId: this.groupId,
          owner: this.border,
          page: this.page,
          pageCount: this.pageCount,
          keyword: this.keyword,
          deptId: this.deptId
        }
      }).then(res => {
        this.loading = false
        if (res.code === 1) {
          if (res.data === null) {
            res.data = {}
            res.data.records = []
          }

          if (res.data.records.length !== 0) {
            res.data.records.map(item => {
              let suffix = item.name.substring(item.name.lastIndexOf('.') + 1).toLowerCase()
              if (suffix === 'xls' || suffix === 'xlsx') {
                item.cover = excel
              } else if (suffix === 'doc' || suffix === 'docx') {
                item.cover = world
              } else if (suffix === 'ppt' || suffix === 'pptx') {
                item.cover = ppt
              } else if (suffix === 'rar' || suffix === 'gzip' || suffix === 'zip' || suffix === 'arj' ||
                suffix === 'tar' || suffix === '7z') {
                item.cover = zipIcon
              } else if (suffix === 'txt') {
                item.cover = txtIcon
              } else if (suffix === 'pdf') {
                item.cover = pdf
              } else {
                item.cover = unknowFileIcon
              }
              return item
            })
            this.list.push(...res.data.records)
          } else {
            //  this.List=[]
            this.finished = true
          }
          if (this.list.length >= res.total) {
            this.finished = true;	// 结束加载状态
          }
        }
      })
    },
    CtListLoad () {
      if (this.list.length > 0) {
        this.finished = false
        this.loading = true
        this.CtDetailList(this.name, true)
      }

    },
    CtFileLoad () {
      if (this.list.length > 0) {
        this.finished = false
        this.loading = true
        this.CtFile(true)
      }
    },

  }
};
</script>
 
<style lang="less" scoped>
</style>
